var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvertedComma2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 48,
    viewBox: "0 0 59 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7593 19.3419C54.6257 8.13521 46.8953 0 39.381 0C38.7774 0 38.1744 0.0525347 37.587 0.156411C37.2539 0.214916 36.9625 0.41073 36.7823 0.694898C36.6026 0.980857 36.5518 1.32831 36.6432 1.65307L38.19 7.18599C38.3392 7.72029 38.8544 8.08147 39.3899 8.057L39.5129 8.05461C42.2996 8.05461 47.3926 12.2312 49.9889 21.5138C50.0916 21.8821 50.1889 22.2588 50.2826 22.6517C47.3681 21.2093 43.8912 20.8756 40.7427 21.7526C33.6397 23.74 29.4787 31.1343 31.4643 38.2361C33.0737 43.9905 38.3673 48.0107 44.3372 48.0107C45.5533 48.0107 46.7675 47.8429 47.9466 47.5128C52.6306 46.2036 56.1522 42.3148 57.8632 36.5651C59.4076 31.3779 59.3688 25.1005 57.7593 19.3419Z",
    fill: "url(#paint0_linear_504_67)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41024 0C7.80788 0 7.20432 0.0513408 6.61748 0.155217C6.28495 0.212529 5.99302 0.409536 5.81333 0.693704C5.63364 0.979663 5.58289 1.32711 5.67363 1.65188L7.22104 7.18479C7.37028 7.7191 7.87594 8.08028 8.42099 8.0558L8.54278 8.05341C11.3295 8.05341 16.4231 12.23 19.0194 21.5126C19.1227 21.8833 19.22 22.26 19.3131 22.6505C16.3974 21.2081 12.9217 20.8744 9.77318 21.7514C2.67136 23.7388 -1.49086 31.1331 0.495927 38.2349C2.10542 43.9893 7.39894 48.0095 13.3689 48.0095C14.5849 48.0095 15.7992 47.8417 16.9789 47.5116C21.6623 46.2024 25.1839 42.3136 26.8955 36.5639C28.4393 31.3767 28.4011 25.0987 26.791 19.3395C23.6556 8.13401 15.9264 0 8.41024 0Z",
    fill: "url(#paint1_linear_504_67)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_504_67",
    x1: 44.9817,
    y1: 0,
    x2: 44.9817,
    y2: 48.0107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#084DAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_504_67",
    x1: 14.0133,
    y1: 0,
    x2: 14.0133,
    y2: 48.0095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#084DAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertedComma2);
export default __webpack_public_path__ + "static/media/invertedComma2.51934f0476dec3bace707dda360429d1.svg";
export { ForwardRef as ReactComponent };